import React from 'react';
import { isMobile } from '../../utils/utils';

const SuggestionBox = React.memo(() => {
    return (
        <iframe title="Suggestion Box" src="https://docs.google.com/forms/d/e/1FAIpQLSeAPU-Bcpv0-lRg7qx7Zc7WdnXG7xniI0iE53oDYk110oS4Fw/viewform?embedded=true" width="640" height={isMobile() ? 720 : 630} frameBorder="0" marginHeight="0" marginWidth="0">Loading…</iframe>
    );
});

export default SuggestionBox;